enum PersonaTournamentStateEnum {
    NONE = 0,
    IN_PROGRESS = 1,
    OPEN = 2,
    FINISHED = 3
}

export default PersonaTournamentStateEnum;